import { en } from './en';
import { ptBR } from './pt-BR';

export const resources = {
    'pt-BR': ptBR,
    en,
} as const;
